import { render, staticRenderFns } from "./BookViewingDialog.vue?vue&type=template&id=bf423c4c&scoped=true&"
import script from "./BookViewingDialog.vue?vue&type=script&lang=ts&"
export * from "./BookViewingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BookViewingDialog.vue?vue&type=style&index=0&id=bf423c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf423c4c",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QSelect,QInput,QPopupProxy,QDate,QTab,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QSelect,QInput,QPopupProxy,QDate,QTab})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
